import { useCalculatorStore } from "../store/calculatorStore";

// Base-aware asset/doc URLs (app is served from the /quanta/ subpath).
const BASE = import.meta.env.BASE_URL;

export function Header() {
  const { activeTab, setActiveTab } = useCalculatorStore();

  return (
    <header className="header">
      <div className="header-left">
        <a
          href="/"
          className="header-back"
          title="Back to knaxly.dev"
        >
          ← knaxly.dev
        </a>
        <a
          href="/"
          className="header-home"
          title="Back to knaxly.dev"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--space-sm)",
            textDecoration: "none",
          }}
        >
          <img src={`${BASE}assets/quanta.png`} alt="Quanta" className="logo-image" />
          <h1 className="logo">Quanta</h1>
        </a>
      </div>

      <nav className="header-nav">
        <button
          className={`nav-tab ${activeTab === "calculator" ? "active" : ""}`}
          onClick={() => setActiveTab("calculator")}
        >
          Calculator
        </button>
        <button
          className={`nav-tab ${activeTab === "history" ? "active" : ""}`}
          onClick={() => setActiveTab("history")}
        >
          History
        </button>
        <button
          className={`nav-tab ${activeTab === "sequences" ? "active" : ""}`}
          onClick={() => setActiveTab("sequences")}
        >
          Sequences
        </button>
        <button
          className={`nav-tab ${activeTab === "marketplace" ? "active" : ""}`}
          onClick={() => setActiveTab("marketplace")}
        >
          Marketplace
        </button>
        <button
          className={`nav-tab ${activeTab === "files" ? "active" : ""}`}
          onClick={() => setActiveTab("files")}
        >
          Files
        </button>
        <a
          className="nav-tab"
          href={`${BASE}docs/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Docs
        </a>
      </nav>

      <div className="header-right">
        <button
          className={`btn-icon ${activeTab === "settings" ? "active" : ""}`}
          onClick={() => setActiveTab("settings")}
          title="Settings"
          aria-label="Settings"
        >
          <SettingsIcon />
        </button>
      </div>
    </header>
  );
}

function SettingsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}
